/* tslint:disable:typedef-whitespace align no-trailing-whitespace import-spacing */

import {Action, ActionType}      from '@/models/action';
import {Logger}                  from '@/util/logger';
import {WindowService}           from '@/services/window.service';
import {ConnectionViewerMetadata} from '@/screens/ide/connection.viewer.metadata';

/**
 *
 * @class ConnectionViewerAction
 *
 * @brief launch a new / blank connection viewer (routes through a decision point)
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      January 2024
 *
 */
export class ConnectionViewerAction extends Action {

  private      windows: WindowService = null;

  constructor(options: any = null) {

    super({
      key:   'window.connectionviewer',
      type:  ActionType.Window_ConnectionViewer,
      label: 'Connection Viewer (Empty)',
      icon:  '<i class="fas fa-project-diagram"></i>',
      tip:   'Launch a connection viewer'
    });

    this.windows  = this.injector().get(WindowService);
  }

  /* is this action enabled? */
  public enabled(): boolean {

    return true;
  }

  /** implement the action */
  public execute(): boolean {

    if (!this.enabled()) {
      return false;
    }

    Logger.debug('[ScenarioBrowseAction] executing...');

    this.windows.launchWindow(new ConnectionViewerMetadata(
      '',
      '',
      ''
    ));

    return true;
  }
}
